import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import type { RootState } from "@/store";
import { supabase } from "@/services/supabase-service";
import { useDispatch } from "react-redux";
import { setCredentials } from "@/store/slices/authSlice";
import LoadingSpinner from "@/components/LoadingSpinner";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated
  );
  const location = useLocation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      if (!isAuthenticated) {
        const {
          data: { session },
          error,
        } = await supabase.auth.getSession();

        if (session) {
          const { user } = session;
          dispatch(
            setCredentials({
              user: {
                id: user.id,
                username: user.email!,
                name: user.user_metadata.name,
              },
              token: session.access_token,
            })
          );
        }
      }
      setIsLoading(false);
    };

    checkAuth();
  }, [isAuthenticated, dispatch]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
